import React from 'react';
import { Helmet } from 'react-helmet-async';
import BackButton from '../components/BackButton';
import './styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <Helmet>
        <title>Privacy Policy | YKI Testi</title>
        <meta name="description" content="Privacy policy for YKI Testi — how we handle your data in our free Finnish language test preparation app." />
        <link rel="canonical" href="https://ykitesti.fi/privacy-policy" />
      </Helmet>

      <BackButton label="Back" />

      <h1 className="privacy-title">Privacy Policy</h1>
      <p className="privacy-subtitle">YKI Testi — Free Finnish Language Test Preparation</p>
      <p className="privacy-updated">Last updated: 10 June 2026</p>

      <div className="privacy-body">

        <p className="privacy-intro">
          This page informs you of our policies regarding the collection, use, and disclosure
          of personal information when you use YKI Testi. By using the app, you agree to the
          collection and use of information in accordance with this policy.
        </p>

        <section className="privacy-section">
          <h2>Information We Collect</h2>
          <p>
            We do not collect personally identifiable information unless explicitly provided by
            you. The information we may collect includes:
          </p>
          <ul>
            <li>
              <strong>Log Data</strong> — When you use the app, your device may send information
              such as your IP address, device type, operating system version, and diagnostic
              statistics. This data is used solely for improving app stability.
            </li>
            <li>
              <strong>Usage Data</strong> — We may collect anonymous information about how the
              app is used, including pages visited, time spent, and features accessed. This helps
              us understand which parts of the app are most useful.
            </li>
            <li>
              <strong>Account Data</strong> — If you choose to sign in with Google, we receive
              your name and email address to identify your account and sync your progress across
              devices. We do not share this with third parties.
            </li>
            <li>
              <strong>Local Storage</strong> — Quiz scores, learned words, study streak, and
              settings are stored locally on your device. This data never leaves your device
              unless you use the sync feature.
            </li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Advertising</h2>
          <p>
            YKI Testi may display advertisements served by Google AdSense. Google may use
            cookies and similar technologies to serve ads based on your prior visits to this
            or other websites. You can opt out of personalised advertising by visiting
            <a href="https://www.google.com/settings/ads" target="_blank" rel="noreferrer"> Google's Ads Settings</a>.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Cookies</h2>
          <p>
            YKI Testi itself does not use cookies. Third-party services such as Google AdSense
            and Google Analytics may set cookies on your device in accordance with their own
            privacy policies.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Data Security</h2>
          <p>
            We take the security of your information seriously. While we strive to use
            commercially acceptable means to protect any personal data, no method of
            transmission over the internet is 100% secure and we cannot guarantee absolute
            security.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Children's Privacy</h2>
          <p>
            YKI Testi does not knowingly collect personally identifiable information from
            children under 13. If you are a parent or guardian and believe your child has
            provided us with personal information, please contact us and we will delete it.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes are effective
            immediately upon posting to this page. We recommend reviewing this page
            periodically.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at{' '}
            <a href="mailto:ykitestiapp@gmail.com">ykitestiapp@gmail.com</a>.
          </p>
        </section>

      </div>
    </div>
  );
};

export default PrivacyPolicy;
